import { create } from 'zustand'
import type { Session, User } from '@supabase/supabase-js'
import type { Client } from '@/types/database'

interface AuthState {
  session: Session | null
  user: User | null
  client: Client | null
  clientId: string | null
  isAdmin: boolean
  loading: boolean
  setSession: (session: Session | null) => void
  setClient: (client: Client | null) => void
  setIsAdmin: (isAdmin: boolean) => void
  setLoading: (loading: boolean) => void
  reset: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
  session: null,
  user: null,
  client: null,
  clientId: null,
  isAdmin: false,
  loading: true,
  setSession: (session) =>
    set({ session, user: session?.user ?? null }),
  setClient: (client) =>
    set({ client, clientId: client?.id ?? null }),
  setIsAdmin: (isAdmin) => set({ isAdmin }),
  setLoading: (loading) => set({ loading }),
  reset: () => set({ session: null, user: null, client: null, clientId: null, isAdmin: false, loading: false }),
}))
